var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-node-expression" },
    [
      _c("div", { staticClass: "wkb-node-expression-head" }, [
        _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
          _vm._v("Expression"),
        ]),
        _c("div", { staticClass: "wkb-node-expression-controls" }, [
          _vm.references.length
            ? _c("label", { staticClass: "wkb-node-expression-field" }, [
                _c("span", { staticClass: "wkb-node-expression-label" }, [
                  _vm._v("Reference"),
                ]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedReferenceId,
                        expression: "selectedReferenceId",
                      },
                    ],
                    staticClass: "wkb-node-expression-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedReferenceId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.references, function (reference) {
                    return _c(
                      "option",
                      {
                        key: reference.reference_id,
                        domProps: { value: reference.reference_id },
                      },
                      [_vm._v(" " + _vm._s(reference.label) + " ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.loading
        ? _c("p", { staticClass: "wkb-inspector-note" }, [
            _c("span", {
              staticClass: "wkb-inspector-spinner",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Loading expression profile… "),
          ])
        : _vm.error
        ? _c(
            "p",
            { staticClass: "wkb-inspector-note wkb-inspector-note--warn" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : !_vm.sortedRows.length
        ? _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v(" " + _vm._s(_vm.emptyNote) + " "),
          ])
        : [
            _c(
              "div",
              { staticClass: "wkb-node-expression-dual" },
              [
                _vm._m(0),
                _vm._l(_vm.pagedRows, function (row) {
                  return _c(
                    "div",
                    {
                      key: row.row_id || `${row.tissue}:${row.cell_type}`,
                      staticClass: "wkb-node-expression-dual-row",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wkb-node-expression-row-label" },
                        [_vm._v(" " + _vm._s(_vm.rowLabel(row)) + " ")]
                      ),
                      _c("div", { staticClass: "wkb-node-expression-metric" }, [
                        _c(
                          "div",
                          { staticClass: "wkb-node-expression-bar-track" },
                          [
                            _c("div", {
                              staticClass:
                                "wkb-node-expression-bar-fill wkb-node-expression-bar-fill--absolute",
                              style: {
                                width: _vm.barWidth(
                                  _vm.absoluteValue(row),
                                  _vm.maxAbsoluteValue
                                ),
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "wkb-node-expression-row-value" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatValue(_vm.absoluteValue(row), 2)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "wkb-node-expression-metric" }, [
                        _c(
                          "div",
                          { staticClass: "wkb-node-expression-bar-track" },
                          [
                            _c("div", {
                              staticClass:
                                "wkb-node-expression-bar-fill wkb-node-expression-bar-fill--relative",
                              style: {
                                width: _vm.barWidth(
                                  _vm.relativeValue(row),
                                  _vm.maxRelativeValue
                                ),
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "wkb-node-expression-row-value" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatValue(_vm.relativeValue(row), 2)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _c("WorkspaceGraphTablePagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.pageCount,
                "aria-label": "Expression profile pages",
              },
              on: {
                "page-change": function ($event) {
                  _vm.currentPage = $event
                },
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-node-expression-dual-header" }, [
      _c("div", {
        staticClass: "wkb-node-expression-dual-header-label",
        attrs: { "aria-hidden": "true" },
      }),
      _c("div", { staticClass: "wkb-node-expression-dual-colhead" }, [
        _c("h5", { staticClass: "wkb-node-expression-col-title" }, [
          _vm._v("Absolute"),
        ]),
        _c("p", { staticClass: "wkb-node-expression-col-note" }, [
          _vm._v(" Mean normalized expression per 10k "),
        ]),
      ]),
      _c("div", { staticClass: "wkb-node-expression-dual-colhead" }, [
        _c("h5", { staticClass: "wkb-node-expression-col-title" }, [
          _vm._v("Relative logP"),
        ]),
        _c("p", { staticClass: "wkb-node-expression-col-note" }, [
          _vm._v(" −log10 relative enrichment p-value "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }